import React, { FC } from 'react';
import { useCloseModal } from '@core/router';

import { CreateInspectionProvider } from '../contexts';
import { CreateInspection } from '../containers';

export const CreateInspectionPage: FC = () => {
  const closeModal = useCloseModal();

  const onClose = React.useCallback(() => {
    closeModal('/@next/branch-inspections');
  }, [closeModal]);

  return (
    <CreateInspectionProvider onCancel={onClose} onSucceed={onClose}>
      <CreateInspection />
    </CreateInspectionProvider>
  );
};
